import { Cookies } from 'react-cookie';
import { checkEnvironment } from 'ui-common/src/lib/utils';

class HttpService {
  cookies = new Cookies();

  headers = () => {
    const buildHeaders = () => ({
      'Content-Type': 'application/json',
      ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
        Authorization: `${this.cookies.get('token_type')} ${this.cookies.get('access_token')}`,
      }),
    });

    /** Ensure we don't fetch until envConfig is set */
    if (Object.entries(checkEnvironment()).length) {
      return buildHeaders();
    }

    return new Promise((res) => {
      const next = () => {
        res(buildHeaders());
        window.document.removeEventListener('event:host/envConfig', next);
      };

      window.document.addEventListener('event:host/envConfig', next);
    });
  };

  async get(url, headers) {
    return (
      await fetch(url, {
        method: 'GET',
        headers: { ...headers, ...(await this.headers()) },
      })
    ).json();
  }

  async post(url, req, errorCallback) {
    const res = await fetch(url, {
      method: 'POST',
      headers: await this.headers(),
      body: JSON.stringify(req),
    });

    if (res.status === 200) {
      return res.json();
    }

    errorCallback(res);

    return res;
  }

  async put(url, req) {
    return (
      await fetch(url, {
        method: 'PUT',
        headers: await this.headers(),
        body: JSON.stringify(req),
      })
    ).json();
  }

  async delete(url, errorCallback) {
    const res = await fetch(url, {
      method: 'DELETE',
      headers: await this.headers(),
    });

    if (res.status === 200) {
      return res.json();
    }

    errorCallback(res);

    return res;
  }

  async postFormData(url, formdata, onsuccess, errorCallback) {
    const headers = await this.headers();

    delete headers['Content-Type'];

    const res = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: formdata,
    });
    const response = await res.json();

    if (res.status === 200) {
      onsuccess(response);

      return response;
    }

    errorCallback(response);

    return response;
  }
}

export default new HttpService();
